import {
	apiBusinessMemosDelete,
	apiBusinessMemosShow,
	apiBusinessMemosUpsert,
	type Memo,
	type SaveMemoRequest
} from '#lib/types/generated/index.js';
import { optimisticDelete, optimisticSave } from '#lib/stores/optimistic.js';
import type { DateTime } from 'luxon';
import { writable } from 'svelte/store';

export const memoStore = writable<Memo[]>([]);

export async function loadMemo(id: string): Promise<Memo> {
	const memo = await apiBusinessMemosShow(id);
	memoStore.update((memos) => {
		const index = memos.findIndex((m) => m.id === memo.id);
		if (index !== -1) {
			memos[index] = memo;
			return [...memos];
		} else {
			return [memo, ...memos];
		}
	});
	return memo;
}

export function saveMemo(memo: Memo): Promise<Memo> {
	const payload: SaveMemoRequest = {
		title: memo.title,
		content: memo.content,
		color: memo.color,
		important: memo.important,
		startDate: memo.startDate?.toISODate() ?? null,
		endDate: memo.endDate?.toISODate() ?? null
	};

	return optimisticSave(memoStore, memo, () => apiBusinessMemosUpsert(memo.id, payload));
}

export function deleteMemo(memo: Memo): Promise<void> {
	return optimisticDelete(memoStore, memo, () => apiBusinessMemosDelete(memo.id));
}

export function memoIsValidAt(date: DateTime, memo: Memo): boolean {
	const targetDate = date.toISODate()!;
	const startDateStr = memo.startDate?.toISODate();
	const endDateStr = memo.endDate?.toISODate();

	if (startDateStr && targetDate < startDateStr) return false;
	if (endDateStr && targetDate > endDateStr) return false;

	return true;
}
